export const ALERT_ACTION = {
  SHOW_ALERT_YN: "SHOW_ALERT_YN_ALERT_ACTION",
  HIDE_ALERT_YN: "HIDE_ALERT_YN_ALERT_ACTION",

  SHOW_ALERT: "SHOW_ALERT_ACTION",
  HIDE_ALERT: "HIDE_ALERT_ACTION",
};
